import { useMutation } from '@tanstack/react-query';

import { craftEmailAgentApi } from './api';

type FeedbackParams = {
  threadId: string;
  messageId: string;
  liked: boolean;
};

export const useCraftEmailFeedback = () => {
  return useMutation<void, Error, FeedbackParams>({
    mutationFn: ({ threadId, messageId, liked }) => craftEmailAgentApi.sendFeedback(threadId, messageId, liked),
    retry: false,
    throwOnError: false,
  });
};
